import request from './axios';

// 卡券相关 API
export default {
  // 获取卡券列表
  getCoupons(params) {
    return request({
      url: '/manage/coupons',
      method: 'get',
      params,
    });
  },

  // 获取卡券详情
  getCouponDetail(id) {
    return request({
      url: `/manage/coupons/${id}`,
      method: 'get',
    });
  },

  // 创建卡券
  createCoupon(data) {
    return request({
      url: '/manage/coupons',
      method: 'post',
      data,
    });
  },

  // 更新卡券
  updateCoupon(id, data) {
    return request({
      url: `/manage/coupons/${id}`,
      method: 'put',
      data,
    });
  },

  // 删除卡券
  deleteCoupon(id) {
    return request({
      url: `/manage/coupons/${id}`,
      method: 'delete',
    });
  },

  // 获取用户卡券列表
  getUserCoupons(params) {
    return request({
      url: '/manage/user-coupons',
      method: 'get',
      params,
    });
  },

  // 获取用户卡券详情
  getUserCouponDetail(id) {
    return request({
      url: `/manage/user-coupons/${id}`,
      method: 'get',
    });
  },

  // 更新用户卡券
  updateUserCoupon(id, data) {
    return request({
      url: `/manage/user-coupons/${id}`,
      method: 'put',
      data,
    });
  },

  // 删除用户卡券
  deleteUserCoupon(id) {
    return request({
      url: `/manage/user-coupons/${id}`,
      method: 'delete',
    });
  },

  // 获取当前用户的优惠券列表
  getUserCouponsList(params) {
    return request({
      url: '/user-coupons',
      method: 'get',
      params,
    });
  },

  // 获取当前用户的优惠券详情
  getUserCouponsDetail(id) {
    return request({
      url: `/user-coupons/${id}`,
      method: 'get',
    });
  },
  
  // 获取创建卡券所需数据
  getCouponCreateData() {
    return request({
      url: '/manage/coupons/create',
      method: 'get',
    });
  },
  
  // 获取编辑卡券所需数据
  getCouponEditData(id) {
    return request({
      url: `/manage/coupons/${id}/edit`,
      method: 'get',
    });
  },

  // 获取手动发券所需数据（优惠券列表和用户搜索）
  getManualIssueData(params) {
    return request({
      url: '/manage/coupons',
      method: 'get',
      params,
    });
  },

  // 搜索用户（通过手机号）
  searchUsers(params) {
    return request({
      url: '/manage/member/list',
      method: 'get',
      params: {
        keyword: params.keyword,
        pageSize: 10,
      },
    });
  },

  // 手动发券给指定用户
  manualIssueCoupon(data) {
    return request({
      url: '/manage/user-coupons/manual-issue',
      method: 'post',
      data,
    });
  },

  // 获取核销记录
  getRedeemLogs(params) {
    return request({
      url: '/api/front/user-coupons/redeem-logs',
      method: 'get',
      params,
    });
  },
};
